export const PROPAGATE_STEP_CHANGE = 'CreateFabricGreetingCard/*/PropagateStepChange';
export const SET_ALL_ASSETS = 'CreateFabricGreetingCard/*/AllAssets';
